import { Component, Input, OnInit } from '@angular/core'
import { collection, getDocs, query, where } from '@angular/fire/firestore'
import { FormGroup, FormControl } from '@angular/forms'
import { AdminClient, BroadLocation, CrmAssignee, FirestoreStructure, LeadClosedReason, LeadStatus } from '@parkupp/core'
import { AdminClientService } from 'src/app/services/admin-client.service'
import { AdminService } from 'src/app/services/admin.service'
import { BsModalRef } from 'ngx-bootstrap/modal'

@Component({
    selector: 'app-edit-parker',
    templateUrl: './edit-parker.component.html',
    styleUrls: ['./edit-parker.component.scss'],
})
export class EditParkerComponent implements OnInit {
    LeadStatus = LeadStatus
    editParkerForm: FormGroup
    @Input() adminClient: AdminClient
    broadLocations: string[] = Object.values(BroadLocation)
    leadStatuses: string[] = Object.values(LeadStatus)
    leadClosedReasons: string[] = Object.values(LeadClosedReason)
    crmAssignees: CrmAssignee[] = []

    constructor(private adminClientService: AdminClientService, public bsModalRef: BsModalRef, private adminService: AdminService) {
        this.editParkerForm = new FormGroup({
            numberOfBays: new FormControl(''),
            broadLocation: new FormControl(''),
            userResponsible: new FormControl(''),
            leadStatus: new FormControl(''),
            leadClosedReason: new FormControl(''),
            comment: new FormControl(''),
        })
    }

    async ngOnInit(): Promise<void> {
        if (this.adminClient) {
            this.editParkerForm.patchValue(this.adminClient)
        }
        await this.loadCrmAssignees()
    }

    async loadCrmAssignees(): Promise<void> {
        const snapshot = await getDocs(query(collection(this.adminService.firestore, FirestoreStructure.CRM_ASSIGNEES), where('active', '==', true)))
        this.crmAssignees = snapshot.docs.map((doc) => new CrmAssignee(doc.data(), doc.id))
    }

    onSubmit(): void {
        Object.assign(this.adminClient, this.editParkerForm.value)

        this.adminClientService.update(this.adminClient).then(() => {
            this.bsModalRef.hide()
        })
    }

    closeModal(): void {
        this.bsModalRef.hide()
    }
}
